import type { SxProps, Theme } from "@mui/material";
import {
  AutoStoriesOutlined as PartnerDirectoryIcon,
  CallSplit as CallSplitIcon,
  DriveFolderUploadOutlined as SecureUploadIcon,
  FolderShared as FolderSharedIcon,
  Handshake as HandshakeIcon,
  HomeOutlined,
  HubOutlined as IntegrationsNavIcon,
  PeopleAlt as PeopleAltIcon,
  PsychologyAlt,
  SmartToy as SmartToyIcon,
  StorageOutlined as StorageIcon,
} from "@mui/icons-material";
import type { ManagementKey, NavKey } from "utils/navModel";

type IconFactory = (sx?: SxProps<Theme>) => React.ReactElement;

export const SIDEBAR_ICONS: Record<NavKey, IconFactory> = {
  home: (sx) => <HomeOutlined sx={sx} />,
  dataStorage: (sx) => <StorageIcon sx={sx} />,
  integrations: (sx) => <IntegrationsNavIcon sx={sx} />,
  ai: (sx) => <PsychologyAlt sx={sx} />,
  partnerDirectory: (sx) => <PartnerDirectoryIcon sx={sx} />,
  secureExchange: (sx) => <SecureUploadIcon sx={sx} />,
};

export const MANAGEMENT_ICONS: Record<ManagementKey, IconFactory> = {
  userManagement: (sx) => <PeopleAltIcon sx={sx} />,
  sftpManagement: (sx) => <FolderSharedIcon sx={sx} />,
  partnerManagement: (sx) => <HandshakeIcon sx={sx} />,
  integrationsPlatform: (sx) => <IntegrationsNavIcon sx={sx} />,
  botsManagement: (sx) => <SmartToyIcon sx={sx} />,
  splittingTools: (sx) => <CallSplitIcon sx={sx} />,
};
